import CampaignIcon from '@mui/icons-material/LocalLibrary';
import CampaignList from './CampaignList';
import CampaignCreate from './CampaignCreate';
import CampaignEdit from './CampaignEdit';

export default {
    list: CampaignList,
    create: CampaignCreate,
    edit: CampaignEdit,
    icon: CampaignIcon,
};
